import { LazyLoad } from '@petconsole/pure-fe-mui';

const DashboardPage = LazyLoad(() => import('./DashboardPage'));

export { DashboardPage };
